import { ArtOrderOffer } from "@/api/art-order/types";
import useArtOrderContract from "@/web3/contracts/ArtOrder/useArtOrderContract";
import { MutationArgs } from "@/web3/contracts/common/types";
import { useMutation } from "@tanstack/react-query";
import { buildContractArtOrder } from "../../helpers";

export default function useCancelArtOrder(
  artOrderOffer: ArtOrderOffer,
  { onSuccess, onError }: MutationArgs = {},
) {
  const artOrderContract = useArtOrderContract();

  const { mutateAsync: cancelArtOrder, isLoading } = useMutation({
    mutationFn: async () => {
      if (!artOrderContract) {
        throw Error("Art contract not defined");
      }

      const order = buildContractArtOrder(artOrderOffer);

      const tx = await artOrderContract.cancelOrder(order);

      return await tx.wait();
    },
    onSuccess,
    onError,
  });

  return { cancelArtOrder, isLoading };
}
